import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { Params } from "~/shared/api/types/params";
import { createInfinitePaginationConfig } from "~/shared/util/createInfinitePaginationConfig";

const PERSONAS_KEYS = {
  all: ["personas"] as const,
  list: (params: Params) => [...PERSONAS_KEYS.all, "list", params] as const,
};

export const PERSONAS_QUERIES = {
  infiniteList: (params: { [key: string]: unknown }) => {
    const paginationConfig = createInfinitePaginationConfig(params, 20);

    return infiniteQueryOptions({
      queryFn: async ({ pageParam = 1, signal }) => {
        const response = await api.get(`/personas`, {
          params: paginationConfig.queryFnParams(pageParam),
          signal,
        });

        return response.data;
      },
      queryKey: PERSONAS_KEYS.list({
        params: paginationConfig.keyParams,
      }),
      ...paginationConfig.opts,
    });
  },
};

export function useInfinitePersonasFilter(params: Record<string, unknown>) {
  return useInfiniteQuery(PERSONAS_QUERIES.infiniteList(params));
}
